import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawer: false,
    title: 'stateTitleTest',
    currentMapProvince: '',
    currentMapLocation: {},
    currentMapZoom: 13,
    currentLanguage: 'en',
    userLocation: {},
    searchTextInputFlag: false,
    provinceList: [
      {
        name: 'British Columbia',
        value: 'bc',
        location: {
          lat: 49.2573,
          lng: -123.1241
        }
      },
      {
        name: 'Alberta',
        value: 'ab',
        location: {
          lat: 51.0537,
          lng: -114.0626
        }
      },
      {
        name: 'Québec',
        normalized: 'Quebec',
        value: 'qc',
        location: {
          lat: 45.5576,
          lng: -73.7241
        },
        languages: [
          {
            label: 'French',
            value: 'fr'
          },
          {
            label: 'English',
            value: 'en'
          }
        ],
      }, {
        name:'Ontario',
        value: 'on',
        location: {
          lat: 43.6542,
          lng: -79.3872
        }
      }],
    searchSchoolList: [],
    searchSchoolListFiltered: [],
    initialSearchSchoolListFilteredCount: 0,
    navigationMenu: [],
    switcherMapList: 'map',
    compareSchool: [],
    dialogCompareSchool: false,
    schoolsData: [],
    schoolsLabel: [],
    schoolsInMap: [],
    currentEducationLevel: 'elementary',
    isFront: false,
    mapKey: 0
  },
  mutations: {
    CURRENT_SCHOOLS_IN_MAP(state, payload) {
      /*console.info({
        "action: ": 'Set schools in map',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");
      console.log(state);*/
      //if (state.switcherMapList != 'list') {
        state.schoolsInMap = payload;
      //}
    },
    CURRENT_MAP_PROVINCE(state, payload) {
      /*console.info({
        "action: ": 'Set map province',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.currentMapProvince = payload;
    },
    USER_LOCATION(state, payload) {
      /*console.info({
        "action: ": 'Set user location',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.userLocation = payload;
    },
    CURRENT_MAP_ZOOM(state, payload) {
      /*console.info({
        "action: ": 'Set map location',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.currentMapZoom = payload;
    },
    CURRENT_MAP_LOCATION(state, payload) {
      /*console.info({
        "action: ": 'Set map location',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.currentMapLocation = payload;
    },
    CURRENT_EDUCATION_LEVEL(state, payload) {
      /*console.info({
        "action: ": 'Set education level',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.currentEducationLevel = payload;
    },
    SEARCH_SCHOOL_LIST(state, payload) {
      /*console.info({
        "action: ": 'Set search school list',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.searchSchoolList = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_NAVIGATION_MENU(state, payload) {
      state.navigationMenu = payload;
    },
    SET_SWITCHER_MAP_LIST(state, payload) {
      state.switcherMapList = payload;
    },
    SEARCH_SCHOOL_LIST_FILTERED(state, payload) {
      /*console.info({
        "action: ": 'Set school list filtered',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.searchSchoolListFiltered = payload;
    },
    INITIAL_SEARCH_SCHOOL_LIST_FILTERED_COUNT(state, payload) {
      state.initialSearchSchoolListFilteredCount = payload;
    },
    SET_COMPARE_SCHOOL(state, payload) {
      /*console.info({
        "action: ": 'Set compare school',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.compareSchool = payload;
    },
    DELETE_COMPARE_SCHOOL: (state, payload) => {
      /*console.info({
        "action: ": 'Delete compare school',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      let index = state.compareSchool.findIndex(school => school.id === payload);
      state.compareSchool.splice(index, 1);
    },
    SET_DIALOG_COMPARE_SCHOOL(state, payload) {
      state.dialogCompareSchool = payload;
    },
    SET_SCHOOLS_DATA(state, payload) {
      /*console.info({
        "action: ": 'Set school data',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.schoolsData = payload;
    },
    DELETE_SCHOOL_DATA(state,payload) {
      /*console.info({
        "action: ": 'Delete school data',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      let index = state.schoolsData.findIndex(school => school.id === payload);
      state.schoolsData.splice(index, 1);
    },
    SET_SCHOOLS_LABEL(state, payload) {
      /*console.info({
        "action: ": 'Set schools label',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.schoolsLabel = payload;
    },
    DELETE_SCHOOL_LABEL(state, payload) {
      /*console.info({
        "action: ": 'Delete schools label',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      let index = state.schoolsLabel.findIndex(school => school.id === payload);
      state.schoolsLabel.splice(index, 1);
    },
    CURRENT_LANGUAGE(state, payload) {
      /*console.info({
        "action: ": 'Set current language',
        "payload": payload,
        time: Math.floor(Date.now() / 1000)
      },"MUTATION");*/
      state.currentLanguage = payload;
    },
    SET_IS_FRONT(state, payload) {
      state.isFront = payload;
    },
    UPDATE_MAP_KEY(state) {
      state.mapKey++;
    }
  },
  actions: {
    setCurrentMapProvince(context , payload) {
      context.commit('CURRENT_MAP_PROVINCE', payload);
    },
    setCurrentEducationLevel(context , payload) {
      context.commit('CURRENT_EDUCATION_LEVEL', payload);
    },
    setUserLocation(context, payload) {
      context.commit('USER_LOCATION', payload);
    },
    setCurrentMapLocation(context, payload) {
      context.commit('CURRENT_MAP_LOCATION', payload);
    },
    setSearchSchoolList(context, payload) {
      context.commit('SEARCH_SCHOOL_LIST', payload);
    },
    deleteCompareSchool(context, payload) {
      context.commit('DELETE_COMPARE_SCHOOL', payload);
    },
    setCurrentLanguage(context, payload) {
      context.commit('CURRENT_LANGUAGE', payload);
      localStorage.setItem('language', payload);
    },
    loadCurrentLanguage(context) {
      const language = localStorage.getItem('language');
      context.commit('CURRENT_LANGUAGE', language);
      return language ? language : 'en';
    }
  },
  getters: {
    getProvinceCode: (state) => (provinceId) => {
      return state.provinceList.find(province => province.value === provinceId).name;
    },
    getCompareSchool: (state) => () => {
      return state.compareSchool;
    }
  }
})
